import React from 'react';
import { Form, useForm, Textarea, SubmitButton, TextAreaParam, Row } from '../../../_lib/Form2';
import { SonForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useDelayed } from '../../../hooks/useDelayed';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { Hint } from '../../../_lib/components/Hint';

type SanctionFormProps = {
  form: SonForm<TextAreaParam<'reason'>>;
  sanctioned: boolean;
  closeModal: () => void;
};

export function SanctionForm({ form, sanctioned, closeModal }: SanctionFormProps) {
  const { t } = useSonTranslation('PersonInteraction');
  const { refresh } = useRefreshBlock();

  const delayedRefreshAndClose = useDelayed(() => {
    refresh();
    closeModal();
  });

  const { formProps, fetchState, params } = useForm({
    form,
    onSuccess: delayedRefreshAndClose,
  });

  const reason = params.getByName('reason');

  return (
    <Form {...formProps}>
      <Row>
        <Hint message={sanctioned ? t('sanction.sanctioned.form.hint') : t('sanction.form.hint')} />
      </Row>
      <Row>
        <Textarea label={t('sanction.form.message.label')} param={reason} autoExpand />
      </Row>
      <SubmitButton
        buttonLabel={sanctioned ? t('sanction.sanctioned.form.submit') : t('sanction.form.submit')}
        messageSending={sanctioned ? t('sanction.sanctioned.form.sending') : t('sanction.form.sending')}
        messageSuccess={sanctioned ? t('sanction.sanctioned.form.success') : t('sanction.form.success')}
        messageFail={sanctioned ? t('sanction.sanctioned.form.fail') : t('sanction.form.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}
